import React from "react";
import { useTranslation } from "react-i18next";

interface LabelStatusMenuProps {
    status: string;
}

const getStatusData = (status: string) => {
    switch (status) {
        case "activated":
            return { classes: "bg-additional-green text-green", title: "Published" };
        case "under-development":
            return { classes: "bg-additional-orange text-orange", title: "In development" };
        case "deactivated":
            return { classes: "bg-additional-grey text-grey", title: "hidden" };
        default:
            return { classes: "bg-additional-grey text-grey", title: "" };
    }
};

const LabelStatusMenu: React.FC<LabelStatusMenuProps> = ({ status }) => {
    const { t } = useTranslation();
    const { classes, title } = getStatusData(status);

    return (
        <div className="d-flex justify-content-center">
            <div
                className={`d-flex align-items-center justify-content-center badge rounded-1 p-2 fs-7 ${classes}`}
                style={{ height: "30px" }}
            >
                {t(title)}
            </div>
        </div>
    );
};

export default LabelStatusMenu;
